import jsonp from './jsonp.js'
import {getDate} from './getDate.js'

export function getArticle (typeids, row, source, pic) {
  return new Promise(function (resolve, reject) {
    jsonp(`http://cmsdt.xdf.cn/get_main_article_for${source}_js.php`, {
      typeids,
      row,
      pic: pic !== undefined ? pic : ''
    }, {timeout: 10000}).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getCMS (url,typeids,row) {
  return new Promise(function (resolve, reject) {
    jsonp(url, {
      typeids,
      row
    }, {timeout: 10000}).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getPopularArticle (categoryCode, cityId) {
  return new Promise(function (resolve, reject) {
    jsonp('http://cmsdt.xdf.cn/get_souke.php', {
      method: 'ClassRecommend.GetTopRegClassByCityCategory',
      timestamp: getDate(0, '-'),
      AppId: 0,
      param: JSON.stringify({
        cityId,
        categoryCode,
        attr: 0,
        size: 6
      }),
      callback: 'callback'
    }, {timeout: 10000}).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/js/getArticle.js